import React, { useState } from "react";
import { AuthorSidebar } from "../Components/AuthorDashboard/AuthorSidebar";
import { AuthorDashboard } from "../Components/AuthorDashboard/AuthorDashboard";
import { MyProduct } from "../Components/AuthorDashboard/MyProduct";
import { MySales } from "../Components/AuthorDashboard/MySales";
import { Payout } from "../Components/AuthorDashboard/Payout";
import { AuthorProfile } from "../Components/AuthorDashboard/AuthorProfile";
import { AddingProducts } from "../Components/AuthorDashboard/AddingProducts/AddingProducts";
import { BillingDetails } from "../Components/AuthorDashboard/BillingDetails";

export const AuthorDashboardPage = () => {
  const [showCurrentTab, setShowCurrentTab] = useState(1);
  const authorSettings = [
    { id: 1, currentPage: <AuthorDashboard /> },
    { id: 2, currentPage: <MyProduct /> },
    { id: 3, currentPage: <MySales /> },
    { id: 4, currentPage: <Payout /> },
    { id: 5, currentPage: <AuthorProfile /> },
    { id: 6, currentPage: <AddingProducts /> },
    { id: 7, currentPage: <BillingDetails /> },
  ];
  return (
    <div className="flex py-4 lg:py-0 px-4">
      <AuthorSidebar
        setShowCurrentTab={setShowCurrentTab}
        currentColor={"bg-[#1C1C1C]  text-white dark:bg-white dark:text-black"}
        currentTab={showCurrentTab}
      />
     
      <div className=" w-full pt-4">

      {authorSettings.map((authorSetting) => {
        if (showCurrentTab === authorSetting.id) {
          return authorSetting.currentPage;
          }
          })}
        </div>
    </div>
  );
};
